/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeIcon, BaSeSmall1, BaSeTheme } from '@base/react';
import React from 'react';
import {
  Container,
  Content,
  ContentAcessibility,
  ContentLogo,
  ContentMenu,
  Drawer,
  Hamburger,
  MenuContainer,
  MenuItem,
  Overlay,
  Separator,
  StyledMarcaSebrae,
} from './style';

import iconMarca from '../../assets/icon-marca.svg';
import imglogo from '../../assets/tradicional.png';
import { useDisplay } from '../../hook/useDisplay';

const menuItems = [
  { name: 'O que é', section: '1' },
  { name: 'Empretec para você', section: '2' },
  { name: 'Características empreendedoras', section: '3' },
  { name: 'Dicas', section: '4' },
  { name: 'Perguntas frequentes', section: '5' },
  { name: 'Depoimentos', section: '6' },
  { name: 'Tenho interesse', section: '7' },
];

function Header() {
  const [active, setActive] = React.useState(0);
  const [isOpen, setIsOpen] = React.useState(false);

  const { isLargeDisplay } = useDisplay();
  const handleMenuClick = React.useCallback((index, sectionId) => {
    setActive(index);
    const section = document.getElementById(sectionId);
    const offset = 94;
    const elementPosition =
      section.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
    setIsOpen(false);
  }, []);

  React.useEffect(() => {
    const handleScroll = () => {
      const offset = 150;
      const windowHeight = window.innerHeight;
      const scrollY = window.scrollY;
      const documentHeight = document.body.scrollHeight;

      if (windowHeight + scrollY >= documentHeight - offset) {
        setActive(menuItems.length - 1);
      } else {
        menuItems.forEach((item, index) => {
          const section = document.getElementById(item.section);
          if (section) {
            const sectionTop = section.offsetTop - 94;
            const sectionBottom = sectionTop + section.offsetHeight;

            if (scrollY >= sectionTop && scrollY < sectionBottom) {
              setActive(index);
            }
          }
        });
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  React.useEffect(() => {
    if (isLargeDisplay()) {
      setIsOpen(false);
    }
  }, [isLargeDisplay]);

  return (
    <Container id="header">
      <Content>
        <ContentAcessibility></ContentAcessibility>
        <span>‎ </span>
        {/* <BaSeLogoSebraeInverse width={40} /> */}
        <StyledMarcaSebrae
          href="https://sebrae.com.br/"
          target="_blank"
          rel="noopener noreferrer"
          iconMarca={iconMarca}
        >
          {/* <StyledImage src={imglogoSebrae} target="_blank" alt="Logo sebrae" /> */}
          Sebrae
        </StyledMarcaSebrae>
      </Content>

      <Separator />

      <ContentMenu>
        <ContentLogo>
          <img src={imglogo} width={138} height={29} alt="Logo  empretec" />
        </ContentLogo>
        <>
          <Hamburger onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? (
              <BaSeIcon
                color="#fff"
                description="Ícone de teste"
                name="close-big"
                size={26}
              />
            ) : (
              <BaSeIcon
                color="#fff"
                description="Ícone de teste"
                name="system/menu-fill"
                size={26}
              />
            )}
          </Hamburger>
          {!isLargeDisplay() && isOpen && (
            <Overlay onClick={() => setIsOpen(false)} />
          )}
          {!isLargeDisplay() && (
            <Drawer isOpen={isOpen}>
              {menuItems.map((item, index) => (
                <MenuItem
                  key={index}
                  isActive={active === index}
                  onClick={() => handleMenuClick(index, item.section)}
                >
                  {active === index && (
                    <div
                      style={{ width: 4, height: 20, backgroundColor: '#fff' }}
                    >
                      ‎
                    </div>
                  )}
                  <BaSeSmall1
                    fontFamily="Nunito"
                    color={BaSeTheme.colors.defaultColors.white}
                  >
                    {item.name}
                  </BaSeSmall1>
                </MenuItem>
              ))}
            </Drawer>
          )}
          {isLargeDisplay() && (
            <MenuContainer>
              {menuItems.map((item, index) => (
                <MenuItem
                  key={index}
                  isActive={active === index}
                  onClick={() => handleMenuClick(index, item.section)}
                >
                  <BaSeSmall1
                    fontFamily="Nunito"
                    color={BaSeTheme.colors.defaultColors.white}
                  >
                    {item.name}
                  </BaSeSmall1>
                </MenuItem>
              ))}
            </MenuContainer>
          )}
        </>
      </ContentMenu>
    </Container>
  );
}

export default Header;
